import { apiFetch } from "./apiFetch";

let cache = new Map();
let inFlight = new Map();
const CACHE_DURATION = 3000; // 3s

// CONSULTAR PARTICIPANTES API
export const getParticipants = async (chatstp) => {
  try {
    if (!chatstp) throw new Error("chatstp não fornecido");

    const now = Date.now();

    // Retorna cache se ainda está válido
    if (cache.has(chatstp)) {
      const cached = cache.get(chatstp);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    // Se já há requisição em voo, reutiliza
    if (inFlight.has(chatstp)) {
      return inFlight.get(chatstp);
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(
          `/messenger/chats/${chatstp}/participants`
        );

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();
        
        cache.set(chatstp, {
          data,
          time: Date.now(),
        });

        return data;
      } finally {
        inFlight.delete(chatstp);
      }
    })();

    inFlight.set(chatstp, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar participantes:", error);
    return null;
  }
};